import SelectClassItem from './SelectClassItem'

export default SelectClassItem
